export enum SidebarStateEnum {
  COLLAPSED = 'collapsed',
  EXPANDED = 'expanded',
  HIDDEN = 'hidden',
}
